import { ForwardedRef, forwardRef } from 'react';

export const IconCheck = forwardRef(
  (props: React.SVGProps<SVGSVGElement>, ref: ForwardedRef<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        {...props}
      >
        <path d="M20 6L9 17 4 12"></path>
      </svg>
    );
  },
);

IconCheck.displayName = 'IconCheck';

export default IconCheck;
